// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProblemWithFigures } from '../schemas/types/problem-types';

interface ProblemListState {
  items: ProblemWithFigures[];
}

const initialState: ProblemListState = {
  items: []
};

const ProblemListSlice = createSlice({
  name: 'problemList',
  initialState,
  reducers: {
    updateProblems: (
      state: ProblemListState,
      action: PayloadAction<ProblemWithFigures[]>
    ) => {
      state.items = action.payload;
    }
  }
});

export const { updateProblems } = ProblemListSlice.actions;
export default ProblemListSlice.reducer;
